<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="isEdit ? 'Edit Customer' : 'Add New Customer'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="isEdit ? 'Save' : 'Create'"
  (nzOnOk)="onSubmitClick()"
  [nzCancelText]="'Cancel'"
>
  <ng-container *nzModalContent>
    <div class="vertical-large content">
      <div class="horizontal">
        <div class="margin-right">
          @if (resume.subData.content?.portraitImageUrl) {
            <div class="portrait-container" (click)="onEditPortraitClick()" [matTooltip]="'Edit Portrait'">
              <img class="portrait-small" [src]="resume.subData.content?.portraitImageUrl" />
              <span class="edit-icon">
                <span nz-icon style="font-size: 20px" class="material-symbols-rounded">edit</span>
              </span>
            </div>
          } @else {
            <button
              class="portrait-small"
              [matTooltip]="'Edit Portrait'"
              nz-button
              nzType="text"
              nzSize="small"
              nzShape="circle"
              (click)="onEditPortraitClick()"
            >
              <span nz-icon style="font-size: 20px" class="material-symbols-rounded">edit</span>
            </button>
          }
        </div>

        <div class="vertical">
          <div class="field-name">
            {{ resume.subData.content!.firstName }} {{ resume.subData.content!.middleName }}
            {{ resume.subData.content!.lastName }}
          </div>
          <button
            nz-button
            nzType="default"
            [nzSize]="'small'"
            nz-popover
            nzPopoverTitle="Change Name"
            [(nzPopoverVisible)]="isChangeNameVisible"
            nzPopoverTrigger="click"
            [nzPopoverContent]="changeNameContentTemplate"
          >
            Change Name
            <ng-template #changeNameContentTemplate>
              <div class="vertical-large">
                <div class="horizontal-large">
                  <div class="vertical">
                    <div class="field-name">First Name</div>
                    <input nz-input [(ngModel)]="resumeNewFirstName" />
                  </div>

                  <div class="vertical">
                    <div class="field-name">Last Name</div>
                    <input nz-input [(ngModel)]="resumeNewLastName" />
                  </div>
                </div>

                <button
                  [nzLoading]="isChangeNameLoading()"
                  class="fit-content right"
                  nz-button
                  [nzType]="'primary'"
                  (click)="onChangeNameClick()"
                >
                  Save
                </button>
              </div>
            </ng-template>
          </button>
        </div>
      </div>
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Basic Info'" [nzActive]="true">
          <div class="vertical-large">
            <div class="vertical">
              <nz-radio-group [(ngModel)]="resume.type" nzButtonStyle="solid">
                <label nz-radio-button [nzValue]="ResumeType.real">Real Customer</label>
                <label nz-radio-button [nzValue]="ResumeType.ai">AI Customer</label>
              </nz-radio-group>
            </div>

            <div class="vertical">
              <div class="field-name">Voice</div>
              <app-select-deepgram [(ngModel)]="resume.subData.content!.voice"></app-select-deepgram>
            </div>

            <div class="vertical">
              <div class="field-name">Pain Points</div>
              @for (item of resume.subData.content!.painPoints; track i; let i = $index) {
                <div class="horizontal">
                  <input nz-input [(ngModel)]="resume.subData.content!.painPoints![i]" placeholder="Pain Point" />
                  <button class="fit-content" nz-button [nzType]="'text'" (click)="onDeletePainPointClick(i)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                  </button>
                </div>
              }
              <button class="fit-content" nz-button [nzType]="'default'" (click)="onAddPainPointClick()">
                Add Pain Point
              </button>
            </div>

            <div class="vertical">
              <div class="field-name">Company</div>
              <nz-select
                nzShowSearch
                nzAllowClear
                nzPlaceHolder="Select a company"
                [(ngModel)]="resume.parentId"
                (ngModelChange)="onCompanyChange($event)"
              >
                @for (company of companyList(); track $index) {
                  <nz-option [nzLabel]="company.title ?? ''" [nzValue]="company.id"></nz-option>
                }
              </nz-select>
              <!-- <input nz-input [(ngModel)]="resume.subData.content!.mostRecentCompany" /> -->
            </div>

            <div class="vertical">
              <div class="field-name">Position</div>
              <input nz-input [(ngModel)]="resume.subData.content!.mostRecentPosition" />
            </div>

            <div class="vertical">
              <div class="field-name">LinkedIn Provider Id</div>
              <input nz-input [(ngModel)]="resume.subData.linkedInProviderId" />
            </div>

            <div class="vertical">
              <div class="field-name">Personality</div>
              <div class="horizontal wrap">
                @for (selectableItem of selectablePersonalityList(); track $index) {
                  <nz-tag
                    class="fit-content personality"
                    nzMode="checkable"
                    [ngClass]="selectableItem.isSelected ? 'selected' : 'not-selected'"
                    [(nzChecked)]="selectableItem.isSelected"
                    (nzCheckedChange)="onPersonalitySelected()"
                    [nzColor]="selectableItem.isSelected ? selectableItem.value.unsafeSubData.color : undefined"
                  >
                    {{ selectableItem.value.title }}
                  </nz-tag>
                }
              </div>
            </div>
          </div>
        </nz-collapse-panel>
        <nz-collapse-panel [nzHeader]="'More Details'" [nzActive]="false">
          <div class="vertical-large">
            <div class="vertical">
              <div class="field-name">Personal Info</div>
              <textarea
                nz-input
                placeholder="Resource Content"
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.personalInformation"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Work Experience</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.workExperience"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Education</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.education"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Skills</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.skills"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Certifications</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.certifications"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Awards</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.awards"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Publications</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.publications"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Languages</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.languages"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Interests</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.interests"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">References</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.references"
              ></textarea>
            </div>

            <div class="vertical">
              <div class="field-name">Other</div>
              <textarea
                nz-input
                [nzAutosize]="{ minRows: 5, maxRows: 20 }"
                [(ngModel)]="resume.subData.content!.otherDetails"
              ></textarea>
            </div>
          </div>
        </nz-collapse-panel>
      </nz-collapse>
      <!-- <button nz-button [nzType]="'primary'" (click)="onSubmitClick()" class="submit-button">
        {{ isEdit ? 'Save' : 'Create' }}
      </button> -->
    </div>
  </ng-container>

  <div *nzModalFooter class="full-width horizontal seperate">
    <button
      nz-button
      nzType="default"
      [nzDanger]="true"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure you want to delete?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="onDeleteClick()"
    >
      Delete
    </button>

    <div class="horizontal">
      <button nz-button nzType="default" (click)="onCancelClick()">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmitClick()">Save</button>
    </div>
  </div>
</nz-modal>

<app-edit-customer-portrait
  [(isVisible)]="isEditCustomerPortraitVisible"
  [resume]="this.resume"
></app-edit-customer-portrait>
